import React from "react";
import "./ConfirmDialog.css";

export default function ConfirmDialog({ icon = "🗑️", title, message, confirmLabel = "Usuń", cancelLabel = "Anuluj", onConfirm, onCancel }) {
  return (
    <div className="confirm-overlay" onClick={onCancel}>
      <div className="confirm-dialog" onClick={(e) => e.stopPropagation()}>
        {icon && <div className="confirm-dialog__icon">{icon}</div>}
        {title && <div className="confirm-dialog__title">{title}</div>}
        {message && <p className="confirm-dialog__message">{message}</p>}
        <div className="confirm-dialog__actions">
          <button className="confirm-dialog__cancel" onClick={onCancel}>
            {cancelLabel}
          </button>
          <button className="confirm-dialog__confirm" onClick={onConfirm}>
            {confirmLabel}
          </button>
        </div>
      </div>
    </div>
  );
}
